<template>
  <div>
    <v-navigation-drawer
      id="appDrawer"
      v-model="drawer"
      :mini-variant.sync="mini"
      :class="{ menu: true, transparent: $vuetify.breakpoint.mdAndUp }"
      :right="$vuetify.rtl"
      :left="!$vuetify.rtl"
      mobile-break-point="960"
      app
      clipped
      width="240"
    >
      <vue-perfect-scrollbar
        :settings="scrollSettings"
        class="drawer-index--scroll"
      >
        <v-flex
          style="height: 100%;"
        >
          <v-list
            dense
            expand
            class="mt-0 pt-0"
          >
            <template v-for="(section, i) in menu">
              <v-divider
                :key="`d-${i}`"
              />
              <v-toolbar
                :key="i"
                dense
                class="elevation-0 mb-3"
              >
                <v-subheader>
                  <span class="text-uppercase">
                    {{ $t(section.header) }}
                  </span>
                </v-subheader>
              </v-toolbar>

              <template v-for="item in section.items">
                <!-- grouped links -->
                <v-list-group
                  v-if="item.items"
                  :key="item.name"
                  :prepend-icon="item.icon"
                  no-action="no-action"
                >
                  <v-list-tile
                    slot="activator"
                    ripple="ripple"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    v-for="(child, i) in item.items"
                    :key="i"
                    :to="genChildTarget(item, child)"
                    :href="child.href"
                    ripple="ripple"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t(child.title) }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="child.action">
                      <v-icon :class="[child.actionClass || 'success--text']">
                        {{ child.action }}
                      </v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>

                <!-- single link-->
                <v-list-tile
                  v-else
                  :key="item.name"
                  :to="!item.href ? { name: item.component } : null"
                  :href="item.href"
                  :disabled="item.disabled"
                  :target="item.target"
                  ripple="ripple"
                  rel="noopener"
                  exact
                >
                  <v-list-tile-action v-if="item.icon">
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-if="item.action">
                    <v-icon :class="[item.actionClass || 'success--text']">
                      {{
                        item.action
                      }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-if="item.count">
                    <v-chip
                      small
                      color="primary"
                      class="caption white--text"
                    >
                      {{
                        item.count
                      }}
                    </v-chip>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </template>

          </v-list>

        </v-flex>

      </vue-perfect-scrollbar>
      <div
        class="drawer-logo"
      >
        <a
          href="https://futureecom.com/"
          target="_blank"
        >
          <v-img
            style="margin: 0 auto;"
            width="100px"
            src="/img/logo_dark_no_top.png"
          />
        </a>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import menu from '@/menu'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'AppDrawer',

  components: {
    VuePerfectScrollbar
  },

  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      mini: false,
      drawer: this.$vuetify.breakpoint.mdAndUp,
      menu: menu,
      scrollSettings: {
        maxScrollbarLength: 160
      }
    }
  },

  computed: {
    computeGroupActive () {
      return true
    },
    computeLogo () {
      return '/static/m.png'
    },

    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav
    }
  },

  created () {
    this.$radio.$on('app-drawer-toggled', () => {
      this.drawer = !this.drawer
      this.$radio.$emit('app-drawer-state', { open: this.drawer })
    })
  },

  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href || !subItem.component) return
      return { name: subItem.component }
    }
  }
}
</script>

<style lang="stylus">
@import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

#appDrawer
  overflow: hidden
  .drawer-index--scroll
    height: calc(100vh - 138px)
    overflow: auto

.drawer-logo
  position: absolute
  bottom: 20px
  width: 100%
</style>
